import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:720px;
    opacity:.95;
    line-height:1.8;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin-bottom:15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    border:1px solid #d8dfef;
    padding:20px;
    border-radius:12px;
    text-align:center;
    font-weight:700;
    color:#1a2e6e;
    margin:25px 0;
}

.back-btn{
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:700;
    margin-bottom:30px;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero{
    padding:55px 20px;
}

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function UnitedKingdomDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇬🇧 United Kingdom</h1>

          <p>
            Earn a globally recognized qualification faster and join a diverse international student community across historic cities in the
            <strong> United Kingdom</strong>.
          </p>
        </div>
      </section>

      <div className="destination-content">
        <h2>🌟 Why Choose the UK for Your Degree?</h2>

        <ul>
          <li>
            <strong>Shorter Course Duration:</strong> Save time and living expenses with 1-year Master's degrees and 3-year Bachelor's programs.
          </li>

          <li>
            <strong>Graduate Route Work Visa:</strong> Stay and work in the UK for 2 years (3 years for Ph.D. graduates) after completing your studies.
          </li>

          <li>
            <strong>World-Class Quality Standard:</strong> Quality Assurance Agency (QAA) audited degrees recognized by top employers worldwide.
          </li>

          <li>
            <strong>Multi-Cultural Student Hub:</strong> Dynamic student life with diverse international communities across historic university towns.
          </li>
        </ul>

        <h2>📋 Essential Checklist: Documents You Need</h2>

        <ul>
          <li>
            <strong>Passport:</strong> Valid for at least 6 months beyond course start date.
          </li>

          <li>
            <strong>Academic Certificates & Transcripts:</strong> Marksheets, graduation certificates, and medium of instruction letters.
          </li>

          <li>
            <strong>Proof of English Proficiency:</strong> IELTS Academic, UKVI IELTS, PTE Academic, or MOI (where accepted).
          </li>

          <li>
            <strong>Statement of Purpose (SOP):</strong> Academic-focused essay detailing course interest and career goals.
          </li>

          <li>
            <strong>Two Letters of Recommendation (LOR):</strong> Academic or professional references.
          </li>

          <li>
            <strong>Proof of Funds & CAS:</strong> Bank statement held for 28 consecutive days to obtain Confirmation of Acceptance for Studies (CAS).
          </li>
        </ul>

        <h2>🚀 Application & Visa Process</h2>

        <div className="process">Profile Evaluation → Conditional Offer → CAS Issuance → Student Visa (TB Check & Biometrics) → Fly to UK!</div>

        <ol>
          <li>
            <strong>Submit Application:</strong> Apply to target UK universities to secure a Conditional Offer Letter.
          </li>

          <li>
            <strong>Clear Credibility Interview & Pre-CAS:</strong> Submit financial proof (28-day bank statement) and pass pre-CAS checks.
          </li>

          <li>
            <strong>Receive CAS Number:</strong> The university issues your official CAS required for the visa application.
          </li>

          <li>
            <strong>Apply for Student Visa:</strong> Complete Tuberculosis (TB) screening, pay IHS (health surcharge), and submit biometrics at VFS.
          </li>
        </ol>

        <div className="highlight">
          <h3>🤝 How Study Buddy Steps In as Your Guide</h3>

          <ul>
            <li>
              <strong>Course & University Shortlisting:</strong> We match academic background and career goals with high-acceptance UK universities.
            </li>

            <li>
              <strong>CAS & Financial Proof Audit:</strong> We verify your 28-day bank statement format to prevent CAS rejection.
            </li>

            <li>
              <strong>Credibility Interview Coaching:</strong> Mock interview sessions to help clear university and visa interview rounds easily.
            </li>

            <li>
              <strong>Pre-Departure & Accommodation Support:</strong> Guidance on student housing, flight booking, and UK airport arrival protocols.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
